(function(){
"use strict";
angular.module('irricrops')
  .directive('tutorial', function(){
    return {
      restrict     : 'E',
      templateUrl  : 'shared/tutorial/tutorial.tmpl.html',
      controllerAs : 'tut',
      scope        : {
        slides : '=slides'
      },
      controller   : ['$scope', '$mdDialog',
      function($scope, $mdDialog){
        var vm    = this;
        vm.slides = $scope.slides;

        vm.showTutorial= function($event){
          $mdDialog.show({
            parent              : angular.element(document.body),
            targetEvent         : $event,
            templateUrl         : 'shared/tutorial/dialogTutorial.tmpl.html',
            locals              : {
              slides: vm.slides
            },
            clickOutsideToClose : true,
            controllerAs        : "dtut",
            controller          : vm.DialogController
          });
        };

        vm.DialogController = ['$scope', '$mdDialog', 'slides',function($scope, $mdDialog,slides){
          var vm = this;
          vm.slides = slides;
          vm.currentIndex   = 0;
          vm.showedTutorial = false;

          vm.hide = function() {
            $mdDialog.hide();
          };

          vm.cancel = function() {
            $mdDialog.cancel();
          };

          vm.setCurrentSlideIndex = function(index){
            vm.currentIndex = index;
          };

          vm.isCurrentSlideIndex = function(index){
            return vm.currentIndex === index;
          };

          vm.prevSlide = function () {
            vm.currentIndex = (vm.currentIndex < vm.slides.length - 1) ? ++vm.currentIndex : 0;
          };

          vm.nextSlide = function () {
            vm.currentIndex = (vm.currentIndex > 0) ? --vm.currentIndex : vm.slides.length - 1;
          };

        }];
      }]
    };
  });

})();
